export const NAME_REGEX = /^[\p{L}][\p{L}\p{M} .'-]*[\p{L}\p{M}]*$/u;
export const NAME_MATCH_SUGGESTION = "Please enter the name using letters. (Spaces, hyphens, and apostrophes (') are allowed.)";